import { render, staticRenderFns } from "./EarningCostBasicTable.vue?vue&type=template&id=1b6483b6&scoped=true&"
import script from "./EarningCostBasicTable.vue?vue&type=script&lang=js&"
export * from "./EarningCostBasicTable.vue?vue&type=script&lang=js&"
import style0 from "./EarningCostBasicTable.vue?vue&type=style&index=0&id=1b6483b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6483b6",
  null
  
)

export default component.exports